import "../styles/pages/footer.scss";

export default function Footer() {
  return (
    <div className="footer" id="contact">
      <div>Site built by me 🤍 </div>
      <div className="social-links">
        <a href="mailto:jk@joycekadibu.com" target="blank">
          Email
        </a>
        <a href="https://linkedin.com/in/jbkad" target="blank">
          LinkedIn
        </a>
        <a href="https://github.com/jbkad" target="blank">
          Github
        </a>
      </div>
    </div>
  );
}
